var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInvalidActivation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed1515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f44e4e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-875 -254)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(875 254)",
    fill: "none",
    stroke: "#5b5e6a",
    strokeWidth: 2,
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 70,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 69,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(884 263)",
    fill: "none",
    stroke: "#5b5e6a",
    strokeWidth: 2,
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 61,
    r: 61,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 61,
    r: 60,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 53,
    transform: "translate(892 271.455)",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(920 299.455)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 13.375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.229,27.583a6.364,6.364,0,0,1-4.687,2.083H10.417a6.25,6.25,0,1,1,0-12.5h3.125a6.364,6.364,0,0,1,4.687,2.083h4.9A10.473,10.473,0,0,0,13.542,13H10.417a10.417,10.417,0,1,0,0,20.833h3.125a10.586,10.586,0,0,0,9.583-6.25Z",
    transform: "translate(0 -13)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.508,13H35.383A10.586,10.586,0,0,0,25.8,19.25h4.9a6.364,6.364,0,0,1,4.687-2.083h3.125a6.25,6.25,0,0,1,0,12.5H35.383A6.364,6.364,0,0,1,30.7,27.583H25.8a10.473,10.473,0,0,0,9.583,6.25h3.125a10.417,10.417,0,1,0,0-20.833Z",
    transform: "translate(1.075 -13)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.667 4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.646,4,16,6.083l6.354,8.438,1.354-.833Z",
    transform: "translate(-16 -4)",
    fill: "#ff9e10",
    stroke: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.663,4l3.646,2.083-6.354,8.438L24.6,13.688Z",
    transform: "translate(-15.642 -4)",
    fill: "#ff9e10",
    stroke: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.663,44.421l3.646-2.083L25.954,33.9l-1.354.833Z",
    transform: "translate(-15.642 -2.754)",
    fill: "#ff9e10",
    stroke: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.646,44.421,16,42.337,22.354,33.9l1.354.833Z",
    transform: "translate(-16 -2.754)",
    fill: "#ff9e10",
    stroke: "#000",
    strokeWidth: 0
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInvalidActivation);
export default __webpack_public_path__ + "static/media/icon-invalid-activation.0042f56b29cd5ef6b04bfab27e70f013.svg";
export { ForwardRef as ReactComponent };